import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addpatientDetails } from "./AppointmentSlice";
import { networkCall } from "./Network";
import { getAvailableTimeSlots } from "./Utility";

export const fetchDoctors = createAsyncThunk("api/fetchDoctors", async () => {
  const response = await networkCall("GET", `/api/clinic_opd/Doctors/clinic_doctors_details?clinic_id=${localStorage.getItem("clinic_id")}&MDT=CP`);
  if (response.status == '0') {
    throw response.message;
  }
  return response.data;
});

const token = localStorage.getItem('token')
const headers = { Authorization: `Bearer ${token}` }

export const bookAppointment = createAsyncThunk(
  "api/bookAppointment",
  async (payload, { dispatch, rejectWithValue }) => {
    console.log("payload", payload);
    let formData = new FormData();
    formData.append("appointment_id", `${payload?.appointment_id ?? ""}`);
    formData.append("clinic_id", localStorage.getItem("clinic_id") || "");
    formData.append("doctor_id", payload?.doctorId || "");
    formData.append("title", `${payload?.title ?? ""}`);
    formData.append("patientName", `${payload?.name ?? ""}`);
    formData.append("patientAge", `${payload?.age ?? ""}`);
    formData.append("patientContactNumber", `${payload?.mobile ?? ""}`);
    formData.append("date", `${payload?.date ?? ""}`);
    formData.append("start_time", `${payload?.start_time ?? ""}`);
    formData.append("end_time", `${payload?.end_time ?? ""}`);
    formData.append("gender", `${payload?.gender ?? ""}`);
    formData.append("email", `${payload?.email ?? ""}`);
    formData.append("cp_id", `${payload?.cp_id ?? ""}`);
    formData.append("service_ids", `${payload?.service_ids ?? ""}`);
    formData.append("procedure_ids", `${payload?.procedure_ids ?? ""}`);
    formData.append("is_new_family_member", `${payload?.is_new_family_member ?? ""}`);
    formData.append("user_role", localStorage.getItem('user_role') ?? "");
    formData.append('loggedin_user_id', localStorage.getItem('user_id'))
    formData.append("MDT", "CP");
    const response = await fetch(global.baseUrl + "/api/clinic_opd/Appointments/book", {
      method: "POST",
      body: formData,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }

    });
    const data = await response.json();
    console.log(data);
    if (data.status == '0') {
      return rejectWithValue(data.message || "Something went wrong");
    } else {
      const refreshedToken = data?.response_token
      if (refreshedToken) {
        localStorage.setItem('token', refreshedToken)
        headers.Authorization = `Bearer ${refreshedToken}`
      }
      dispatch(
        addpatientDetails({
          userAge: payload?.age,
          name: payload?.name,
          mobile: payload?.mobile,
          title: payload?.title,
        })
      );
    }
  }
);

export const fetchSlots = createAsyncThunk(
  "api/fetchSlots",
  async (payload) => {
    console.log(payload);
    const url = `/api/clinic_opd/Appointments/doctor_weekday_slots?doctor_id=${payload?.id}&dow=${payload?.date}&clinic_id=${payload?.clinic_id || localStorage.getItem('clinic_id')}&MDT=CP`;
    const response = await networkCall("GET", url);
    console.log(response);
    if (response.status == '0') {
      throw response.message;
    }
    return response.data;
  }
);

const ApiSlice = createSlice({
  name: "api",
  initialState: {
    loading: false,
    error: null,
    doctors: [],
    slotList: [],
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDoctors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        alert(action.error.message);
      })
      .addCase(fetchDoctors.fulfilled, (state, action) => {
        state.loading = false;
        state.doctors = action.payload;
      });

    builder
      .addCase(fetchSlots.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSlots.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        alert(action.error.message);
      })
      .addCase(fetchSlots.fulfilled, (state, action) => {
        state.loading = false;
        const data = action.payload[0];
        state.consultationLength = data?.consultation_length || 0;
        console.log("data is ", data);
        console.log("start", data?.start_time);
        console.log("end", data?.end_time);
        console.log("length", data?.consultation_length);
        const slots = getAvailableTimeSlots(
          data?.start_time,
          data?.end_time,
          data?.consultation_length
        );
        if (action.payload.length > 1) {
          const data2 = action.payload[1];
          const slots2 = getAvailableTimeSlots(
            data2?.start_time,
            data2?.end_time,
            data2?.consultation_length
          );

          const slots3 = slots.concat(slots2);
          console.log("slots3:", slots3);
          state.slotList = slots3;
        }
        else {
          state.slotList = slots;

        }


        console.log("state.slotList:", state.slotList);
        console.log("Updated consultationLength:", state.consultationLength);

      });

    builder
      .addCase(bookAppointment.pending, (state) => {
        state.error = null;
        state.loading = true;
      })
      .addCase(bookAppointment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
        alert(state.error);
        console.log("state.error", action.payload);
      })
      .addCase(bookAppointment.fulfilled, (state, action) => {
        state.loading = false;
      });
  },
});

export default ApiSlice.reducer;